import { Component, Inject, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TUI_IS_IOS, TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { TabsService } from './tabs.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/config.service';
import { GlobalDataService } from '../../services/global-data.service';

@Component({
  selector: 'app-backoffice',
  templateUrl: './tabs.backoffice.html',
  styleUrls: ['./tabs.backoffice.css']
})
export class TabBackOfficeComponent {
  isVisible$ = this.tabsService.isVisible$;
  window = window;
  transfersUrl = "" 
  creditsUrl = "" 
  isMenuExpanded = false;
  isTransaccionesOpen = false;
  isconfigsopen = false;

  constructor(
    public router: Router,
    private globalDataService: GlobalDataService,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    @Inject(TUI_IS_IOS) readonly isIos: boolean,
    private tabsService: TabsService
  ) {
    this.transfersUrl = this.globalDataService.transfersUrlData
    this.creditsUrl = this.globalDataService.creditsUrlData
  }

  toggleMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
  }

  toggleTransacciones() {
    if (!this.isMenuExpanded) {
      this.isMenuExpanded = true;
      if (this.isTransaccionesOpen) return;
    }
    this.isTransaccionesOpen = !this.isTransaccionesOpen;
  }

  toggleconfig() {
    if (!this.isMenuExpanded) {
      this.isMenuExpanded = true;
      if (this.isconfigsopen) return;
    }
    this.isconfigsopen = !this.isconfigsopen;
  }
}
